module.exports = __webpack_public_path__ + "static/media/gallery_empty.7df5f6fb.png";